import { NotificationChannelProduct } from './notification-channel-product.interface';

/**
 * One channel a receiver holds notification subscriptions on.
 */
export interface NotificationChannel {
  /**
   * The channel this subscription belongs to, as a `chl-<uuid>` reference.
   */
  channelRef: string;

  /**
   * The per-product subscriptions on this channel.
   */
  products: NotificationChannelProduct[];
}
